import { asInternalEvent } from '@cld/widget-iframe-creator-core';

export const SIGN = asInternalEvent('sign', 'parent');
export const TRIGGER_EXPORT = asInternalEvent('triggerExport', 'parent');
